import { createApp } from "vue";
import App from "./App.vue";
import Datepicker from "@vuepic/vue-datepicker";
import "canvas-datagrid";
import downloader from "@/plugins/downloader";
import * as printHtml from "@/plugins/print-html";
import * as csvHtml from "@/plugins/csv-html";
import * as copyHtmlToClipboard from "@/plugins/copy-to-clipboard";
import autosizeTextarea from "@/plugins/autosize-textarea";
import "@vueform/multiselect/themes/default.css";
import MultiSelect from "@vueform/multiselect";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
import "jquery/src/jquery.js";
import "element-plus/dist/index.css";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import { initWhiteLabelTheme } from "@/core/plugins/white-label";
import BootstrapVue3 from "bootstrap-vue-3";
//import "bootstrap/dist/css/bootstrap.css";
//import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import "@/core/plugins/prismjs";
import swal from "@/plugins/swal";

const app = createApp(App);
app.use(downloader);
app.use(swal);
app.use(store);
app.use(router);
app.use(BootstrapVue3);
app.use(autosizeTextarea);
app.use(ElementPlus);
app.use(csvHtml);
app.use(copyHtmlToClipboard);
app.component("MultiSelect", MultiSelect);

app.use(printHtml, {
  target: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
  ],
});

app.component("date-picker", Datepicker);

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initWhiteLabelTheme(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
